import React from "react";
import { useTranslation } from "react-i18next";

const LegalDocument = ({ type, embedded = false }) => {
  const { t } = useTranslation();
  const baseKey = type === "privacy" ? "legal.privacy" : "legal.terms";
  const sections = t(`${baseKey}.sections`, { returnObjects: true });

  const content = (
    <div className="mx-auto max-w-4xl rounded-3xl border border-white/10 bg-slate-900/70 p-8 shadow-2xl shadow-cyan-500/10 backdrop-blur-xl">
      <header className="mb-8 space-y-3">
        <p className="text-xs uppercase tracking-[0.35em] text-cyan-200/70">
          {t(`legal.links.${type}`)}
        </p>
        <h1 className="text-3xl font-semibold text-white">
          {t(`${baseKey}.title`)}
        </h1>
        <p className="text-sm text-slate-300">{t(`${baseKey}.intro`)}</p>
        <p className="text-xs text-slate-400">
          {t("legal.effectiveDateLabel", { date: "2026-05-07" })}
        </p>
      </header>

      <main className="space-y-6">
        {Array.isArray(sections) &&
          sections.map((section) => (
            <section
              key={section.title}
              className="rounded-2xl border border-white/10 bg-slate-950/40 p-5"
            >
              <h2 className="text-lg font-semibold text-cyan-100">
                {section.title}
              </h2>
              <p className="mt-2 text-sm leading-7 text-slate-300">
                {section.content}
              </p>
            </section>
          ))}
      </main>
    </div>
  );

  if (embedded) {
    return <div className="mx-auto max-w-5xl">{content}</div>;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 px-4 py-12 text-white">
      {content}
    </div>
  );
};

export default LegalDocument;